export default __webpack_public_path__ + "static/media/contact-right-bottom-bg.d3409ac4.png";